var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarlyNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "24px",
    viewBox: "0 0 102 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A8290D71-925D-42F9-B5A2-F21A6338CF45") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marketplace",
    transform: "translate(-170.000000, -37.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 0,
    y: 0,
    width: 1440,
    height: 3914
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#171717",
    x: 0,
    y: 0,
    width: 1440,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(170.000000, 37.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86458219,13.1575675 C5.38856642,12.5242226 4.1453291,11.9700459 4.1453291,10.624188 C4.1453291,9.27833014 5.96862337,8.32831282 8.70446829,8.32831282 C11.6878765,8.32831282 13.9267879,9.7533388 14.5899682,11.8908778 L17.9058701,11.0991967 C17.2426897,7.93247227 13.2636075,5.47826087 8.78759172,5.47826087 C3.97908225,5.47826087 0.7463038,7.53663172 0.7463038,10.7033561 C0.7463038,13.6325762 3.0665316,15.1367703 9.61521192,16.0076195 C13.760541,16.5617962 15.1700252,17.2743092 15.1700252,18.7785033 C15.1700252,20.2826974 13.1804841,21.1535466 9.94770562,21.1535466 C6.21799365,21.1535466 3.97908225,19.7285206 3.31590187,16.8784687 L0,17.5891824 C0.580056949,21.4684198 4.5591392,24 9.94770562,24 C15.1700252,24 18.6521739,21.9416291 18.6521739,18.7749048 C18.6521739,15.6099796 16.2470157,14.1075848 9.86458219,13.1575675 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.437447,2.08695652 L23.6969844,2.08695652 L23.6969844,5.78076724 L19.9565217,5.78076724 L19.9565217,9.21465668 L23.6969844,9.21465668 L23.6969844,18.515079 C23.6969844,21.399839 26.0186508,23.7391304 28.8816762,23.7391304 L34.9565217,23.7391304 L34.9565217,20.0453197 L27.437447,20.0453197 L27.437447,9.21465668 L34.9565217,9.21465668 L34.9565217,5.78076724 L27.437447,5.78076724 L27.437447,2.08695652 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "52.2506976 8.16084226 52.2470603 8.16449492 49.8318906 5.73913043 39 5.73913043 39 9.3351716 50.7503098 9.3351716 39 18.5325628 39 23.4782609 53.4109975 12.0618803 53.4109975 23.4782609 56.7391304 23.4782609 56.7391304 12.6481318 54.4458104 10.365221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "101.086957 5.73913043 97.7585836 5.73913043 97.7585836 17.1561811 83.3478261 5.73913043 83.3478261 10.6854218 95.0995428 19.8830695 83.3478261 19.8830695 83.3478261 23.4782609 94.1796683 23.4782609 96.5936531 21.0536692 96.5973106 21.0573268 98.7973286 18.8503595 101.086957 16.568961"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "79.9565217 0 76.173913 0 76.173913 23.7391304 79.9565217 23.7391304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2587745,8.48614125 L64.0922818,8.48614125 L64.0922818,5.79832553 L60.5217391,5.79832553 L60.5217391,23.4782609 L64.0922818,23.4782609 L64.0922818,9.3972344 L72.6521739,9.3972344 L72.6521739,5.47826087 L68.9078998,5.47826087 C66.9136078,5.47826087 65.2903048,6.35116449 64.2587745,8.48614125 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlyNewLogo);
export default __webpack_public_path__ + "static/media/starly-new-logo.d9c2f39d19fe26b7501002adef57b9d0.svg";
export { ForwardRef as ReactComponent };